<template>
    <div class="loader" :class="{'lg': spinnerSize === 'large', 'sm': spinnerSize === 'small'}">Loading...</div>
</template>

<script>
    export default {
        name: "spinner",
        props: {
            size: String,
        },
        data() {
            return {
                spinnerSize: ""
            }
        },
        mounted() {
            if (this.size !== undefined) {
                this.spinnerSize = this.size;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .loader,
    .loader:after {
        border-radius: 50%;
        width: 2.5em;
        height: 2.5em;
    }
    .loader {
        margin: 0 auto;
        font-size: 10px;
        position: relative;
        text-indent: -9999em;
        border-top: 0.25em solid rgba(255, 255, 255, 0.2);
        border-right: 0.25em solid rgba(255, 255, 255, 0.2);
        border-bottom: 0.25em solid rgba(255, 255, 255, 0.2);
        border-left: 0.25em solid #ffffff;
        -webkit-transform: translateZ(0);
        -ms-transform: translateZ(0);
        transform: translateZ(0);
        -webkit-animation: load8 1.1s infinite linear;
        animation: load8 1.1s infinite linear;
    }

    .loader.lg,
    .loader.lg:after {
        border-radius: 50%;
        width: 5em;
        height: 5em;
    }

    .loader.lg {
        margin: 0 auto;
        border-top: 0.5em solid rgba(255, 255, 255, 0.2);
        border-right: 0.5em solid rgba(255, 255, 255, 0.2);
        border-bottom: 0.5em solid rgba(255, 255, 255, 0.2);
        border-left: 0.5em solid #ffffff;
    }

    .loader.sm,
    .loader.sm:after {
        border-radius: 50%;
        width: 1em;
        height: 1em;
    }

    .loader.sm {
        margin: 0 auto;
        border-top: 0.1em solid rgba(255, 255, 255, 0.2);
        border-right: 0.1em solid rgba(255, 255, 255, 0.2);
        border-bottom: 0.1em solid rgba(255, 255, 255, 0.2);
        border-left: 0.1em solid #ffffff;
    }
    @-webkit-keyframes load8 {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
    @keyframes load8 {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
</style>